import { useNavigate, useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAppDispatch } from "../../store/hooks";
import { resetPasswordThunk } from "../../store/features/auth/authSlice";
import classes from "./styles.module.scss";
import { InputField } from '../../components/InputField';
import { MainButton } from '../../components/MainButton';
import { showNotification } from "../../store/features/notifications/notificationSlice";

export const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [token, setToken] = useState("");
  const [newPasswordError, setNewPasswordError] = useState<string | null>(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState<string | null>(null);

  useEffect(() => {
    const tokenFromUrl = searchParams.get("token");
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    } else {
      dispatch(showNotification({ message: "Invalid reset link.", type: "error" }));
      navigate("/signin");
    }
  }, [searchParams, dispatch, navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      dispatch(showNotification({ message: "Passwords do not match.", type: "error" }));
      return;
    }

    if (newPasswordError || confirmPasswordError) {
      return;
    }

    dispatch(resetPasswordThunk({ token, new_password: newPassword }))
      .unwrap()
      .then(() => {
        navigate("/signin");
        dispatch(showNotification({ message: "Password reset successfully.", type: "success" }));
      })
      .catch(() => {
        dispatch(showNotification({ message: "Failed to reset password.", type: "error" }));
      });
  };

  return (
    <div className={classes.ResetPasswordPage}>
      <div className={classes.contentWrapper}>
        <div className={classes.logo} onClick={() => navigate("/")} >.shortform</div>
        <div className={classes.infoWrapper}>
          <h2>Reset your password</h2>
          <div className={classes.infoText}>
            <p>Enter your new password below.</p>
          </div>
        </div>
        <div className={classes.formWrapper}>
          <InputField
            label='New Password'
            type='password'
            role='password'
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            onValidationError={setNewPasswordError}
          />
          <InputField
            label='Confirm New Password'
            type='password'
            role='password'
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            onValidationError={setConfirmPasswordError}
          />
          <MainButton title='Reset Password' variant='primary' fullWidth onClick={handleSubmit} disabled={!newPassword || !confirmPassword || newPassword !== confirmPassword || !!newPasswordError || !!confirmPasswordError} />
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
